import { createSelector } from 'reselect'

import { selectAppState } from 'src/core/store/selectors/selectAppState'

export const selectAuthError = createSelector([selectAppState], ({ authError }) => authError)
